export class AuthLoginResult {
  public success: boolean = false;
  public message: string = "";
  public redirectTo: string = "";
  public refreshtoken: string = "";
  public token: string = "";
  public user: any = null;
}
